import PatientInfoContent from "./PatientInfoContent";
import styles from "./PatientInfo.module.scss";
import React from "react";
import LoginAlertDialog from "../appMode/LoginAlertDialog";

const PdfModal = React.lazy(() => import("../../components/pdfModal"));

const PatientInfoApp = () => {
  return (
    <div className={styles.appMode}>
      <LoginAlertDialog />
      <PatientInfoContent showPdfInstruction={false} />
      <PdfModal />
    </div>
  );
};

export default PatientInfoApp;